import { render, staticRenderFns } from "./CloseableFilterBadgeContainer.vue?vue&type=template&id=0f807ff0&scoped=true&"
import script from "./CloseableFilterBadgeContainer.vue?vue&type=script&lang=js&"
export * from "./CloseableFilterBadgeContainer.vue?vue&type=script&lang=js&"
import style0 from "./CloseableFilterBadgeContainer.vue?vue&type=style&index=0&id=0f807ff0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f807ff0",
  null
  
)

export default component.exports